import Icon from '../../components/Icon.vue'

Icon.register({"brands/periscope":{"width":448,"height":512,"paths":[{"d":"M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4 18.5 289.5 76.3 374.2 101.2 407.1 137.8 455.5 192.6 512 226.6 512 268.2 512 339.5 417.8 347.5 407 372.1 373.9 429.5 288.7 429.5 214.4 429.5 157.9 408.4 104.3 370 63.6zM226.6 493.9C184.1 493.9 36.6 326.6 36.6 214.5 36.6 107.1 120.5 18.2 226.6 18.2 327.4 18.2 411.3 107.2 411.3 214.5 411.4 326.6 263.9 493.9 226.6 493.9zM338 206.8C338 265.9 286.9 316.5 227.2 316.5 126.6 316.5 76.5 208.3 134.3 134.7V135.1C134.3 159.6 154.4 179.5 179.1 179.5 203.8 179.5 223.9 159.6 223.9 135.1 223.9 116.9 212.8 101.3 197 94.4 273.6 75.2 338 133.7 338 206.8z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/periscope.js
// module id = Mkvd
// module chunks = 0